<template>
    <div class="progressbar-wrapper" v-bind:class="{['variant-'+variant]: variant}">
        <div class="progress" v-bind:style="{width: percentage + '%'}"></div>
    </div>
</template>
<script>
    export default {
        name: 'ProgressBar',
        components: {

        },
        props: {
            variant: {
                type: String,
                default: 'neutral'
            },
            percentage: {
                type: Number,
                default: 50
            }
        },
        data () {
            return {
            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./ProgressBar.scss" scoped lang="scss"></style>

